import Cookies from "js-cookie";
import { of } from "rxjs";
import { mobileRegex } from "./regex";

export const permissionArray: string[] = [
  "add user",
  "get user",
  "get user list",
  "update user",
  "delete user",
  "add role",
  "get role",
  "get role list",
  "update role",
  "delete role",
  "delete permission",
  "add permission",
  "get permission",
  "get permission list",
  "get role permission list",
  "add role permission list",
  "get role permission",
  "update role permission",
  "delete role permission",
  "get category",
  "delete category",
  "get category list",
  "add category list",
  "update category",
  "update product",
  "add product",
  "get product",
  "get product list",
  "delete product",
  "delete product image",
  "get product image",
  "get product image list",
  "add product image",
  "update product image",
  "create single sub-category",
  "fetch single sub-category",
  "update single sub-category",
  "get sub-category list",
  "delete sub-category",
  "create single vendor",
  "delete single vendor",
  "get single vendor",
  "get vendor list",
  "update vendor list",
  "get dashboard analytics",
  "get top product",
  "get near expiry product",
  "get sales report",
  "update campaign status",
  "update vendor status",
  "get order list",
  "update order status",
  "update order payment status",
  "update order delivery status",
  "get delivery status of order",
];

export const saveToken = (key: string, token: string) => {
  sessionStorage.setItem(key, token);
};

export const getToken = (key: string): string =>
  sessionStorage.getItem(key) ?? "";

export const setItem = (key: string, data: any) => {
  localStorage.setItem(key, data);
};

export const getItem = (key: string) => {
  return localStorage.getItem(key);
  // return item ? JSON.parse(item) : null;
};

export const isCookiePresent = (cookieName: string) => {
  return Cookies.get(cookieName) !== undefined;
};
interface UserData {
  email?: string;
  userId?: string;
  userName?: string;
  Permissions?: string[];
  [key: string]: any;
}
export const getCurrentUser = (key?: keyof UserData) => {
  let user: any;
  const currentUserCookie = Cookies.get("currentUser");
  if (currentUserCookie) {
    const currentUser = JSON.parse(currentUserCookie);
    user = currentUser;
  }
  return user;
};

export const clearOnLogout = () => {
  sessionStorage.removeItem("referraltoken");
  localStorage.removeItem("user");
  localStorage.removeItem("distributorId");
  localStorage.removeItem("username");
  localStorage.removeItem("currency");
  localStorage.removeItem("disretailerId");
  localStorage.removeItem("distributorName");
  localStorage.removeItem("email");
  localStorage.removeItem("otpEmail");
};

export function getPermissions$() {
  let user: any = null;

  // const permissions = localStorage.getItem("Permissions");
  const currentUser = Cookies.get("currentUser");

  // if (permissions || currentUser) {
  //   user = {
  //     Permissions: permissions ? JSON.parse(permissions) : null,
  //     currentUser: currentUser ? JSON.parse(currentUser) : null,
  //   };
  // }

  return of(user);
}

export const combineClasses = (...classes: (string | undefined | false)[]) =>
  classes.filter(Boolean).join(" ");

export const env = (key?: keyof ImportMetaEnv) => {
  return key ? import.meta.env[key] : import.meta.env;
};

export const requiredMessage = (name: string) => `${name} is required!`;

// export const onlyNumbersInput = (e: KeyboardEvent) => {
//   ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();
// };
export const onlyNumbersInput = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (["e", "E", "+", "-", "."].includes(e.key)) {
    e.preventDefault();
  }
};
export const onlyNumbersInputWithDecimal = (
  e: React.KeyboardEvent<HTMLInputElement>
) => {
  const { key, currentTarget } = e;
  const value = currentTarget.value;

  // Block scientific notation and signs
  if (["e", "E", "+", "-"].includes(key)) {
    e.preventDefault();
    return;
  }

  // Allow only ONE decimal point
  if (key === "." && value.includes(".")) {
    e.preventDefault();
    return;
  }

  // Restrict to 2 digits after decimal
  if (value.includes(".")) {
    const decimalPart = value.split(".")[1] ?? "";

    // Allow backspace
    if (decimalPart?.length >= 2 && /\d/.test(key)) {
      e.preventDefault();
    }
  }

  // Allow only numbers and dot
  if (!/[0-9.]/.test(key) && key !== "Backspace" && key !== "Tab") {
    e.preventDefault();
  }
};

export const amountValidation = {
  pattern: {
    value: /^\d+(\.\d{1,2})?$/,
    message: "Enter a valid amount (up to 2 decimal places)",
  },
  // max: {
  //   value: 1000000,
  //   message: "Value cannot exceed 10 lakh",
  // },
  min: {
    value: 0,
    message: "Value cannot be negative",
  },
};



// export const capitalizeText = (text?: string) => {
//   if (!text) return "";
//   return text
//     ?.split(" ")
//     ?.map((x) => (x.length > 0 ?  x[0].toUpperCase() + x.slice(1): ""))
//     ?.join(" ");
// };

export const capitalizeText = (text?: string) => {
  if (!text) return "";
  return text
    .split(" ")
    .map((word) => {
      const [first, ...rest] = word;
      return first ? first.toUpperCase() + rest.join("") : "";
    })
    .join(" ");
};

export const CURRENCY_SYMBOL = "₹";

export const getInitialValues = <T extends Record<string, any>>(config: T) =>
  Object.fromEntries(
    Object.entries(config).map(([key, val]) => [key, val.defaultValue])
  );

// export const getSelectOptions = <T extends Record<string, any>>(data: T[], labelKey = "name", valueKey = "id") =>
//   data?.map((row) => ({
//     label: row?.[labelKey] ?? row,
//     value: row?.[valueKey] ?? row,
//   })) ?? [];

export const getSelectOptions = (arr?: { label: any; value: any }[]) =>
  (arr ?? []).map((item) => ({
    label: String(item.label),
    value: String(item.value),
  }));

export const createEnum = (obj: Record<string, any>) => {
  Object.freeze(obj);
};

export const dateConverter = (str: string | Date) => {
  const d = new Date(str);
  let mm = d.getMonth() + 1;
  let dd = d.getDate();

  return [
    (dd > 9 ? "" : "0") + dd,
    (mm > 9 ? "" : "0") + mm,
    d.getFullYear(),
  ].join("-");
};

// export const inputDateFormat = (date) =>
//   new Date(date).toISOString().split("T")[0].split("/").reverse;

export const inputDateFormat = (date?: string | Date) =>
  date ? new Date(date).toISOString().split("T")[0] : "";

export const today : any = new Date().toISOString().split("T")[0];

export const addDaysToDate = (dateStr: string, days: number) => {
  if (!dateStr) return undefined;

  const date = new Date(dateStr);
  date.setDate(date.getDate() + days);

  return date.toISOString().split("T")[0];
};


export const updateParams = (
  params: Record<string, any>,
  setParams: React.Dispatch<React.SetStateAction<Map<string, any>>>
) => {
  setParams((prev) => {
    Object.entries(params || {}).forEach(([key, value]) => {
      prev.set(key, value);
    });
    return prev;
  });
};

export const addBaseUrl = (url?: string) => {
  return url ? `${env("VITE_API_BASE_URL")}/${url}` : "";
};

export const checkPermission = (permission?: string | boolean) => {
  if (typeof permission === "boolean") {
    return permission;
  }
  let currentUser: any;
  let permissionsArray: any = [];
  let roles: any;
  getPermissions$().subscribe((x) => {
    currentUser = { Permissions: x.Permissions };
    roles = x.currentUser;
    currentUser.Permissions.forEach((element: any) => {
      permissionsArray.push(element.SystemName);
    });
  });
  return permissionsArray.includes(permission);
};

export const conditionalColumns = <T>(
  condition: boolean,
  columns: T[] | T
): T[] => {
  const colArray = Array.isArray(columns) ? columns : [columns];
  return condition ? colArray : [];
};

export const formatNumberWithSuffix = (value: number, roundDigits = 1) => {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(roundDigits)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(roundDigits)}k`;
  return value.toString();
};

export const pick = <T extends Record<string, any>>(
  obj: T,
  keys: (keyof T)[]
): Partial<T> => {
  return keys.reduce((acc, key) => {
    if (key in obj) {
      acc[key] = obj[key];
    }
    return acc;
  }, {} as Partial<T>);
};

export const statusList = [
  { label: "Approved", value: "Approved" },
  { label: "Pending", value: "Pending" },
  { label: "Rejected", value: "Reject" },
  { label: "Delivered", value: "Delivered" },
  { label: "Partial Delivered", value: "PartialDelivered" },
];

export const retailerStatusList = [
  { label: "Approved", value: "Approved" },
  { label: "Pending", value: "Pending" },
  { label: "Rejected", value: "Reject" },
];


export const mobileValidation = {
  required: "Mobile Number is required",
  pattern: {
    value: mobileRegex,
    message: "Mobile number must be 6 to 15 digits",
  },
};

export const toUTCISOStringWithCurrentTime = (
  dateValue: string | Date | null | undefined
) => {
  if (!dateValue) return null;

  const selectedDate = new Date(dateValue);
  if (isNaN(selectedDate.getTime())) return null;

  const now = new Date();

  // Set current time into selected date
  selectedDate.setHours(
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    now.getMilliseconds()
  );

  return selectedDate.toISOString();
};

export const formatAmount = (amount : number) => {
  if (amount === null || amount === undefined || amount === 0) {
    return "0";
  }

  return Number(amount).toLocaleString("en-IN", {
    maximumFractionDigits: 2,
  });
};